import { actionColumn } from '@rxweb/grid';
import {vRoleBase} from '../database-models/v-role-base';
//Generated Imports
@actionColumn({
    name: 'action',
    allowSorting: false,
    configuredTemplate: { templateName: 'editAction' }, columnIndex: 0, headerTitle: "Action", class: ["actionFild"],headerCellClass:["pl-4"]
})
export class vRole extends vRoleBase 
{




//#region Generated Reference Properties

//#endregion Generated Reference Properties












}